import { Button, Input, Spinner, Typography } from "@material-tailwind/react"
import { useForm, SubmitHandler } from "react-hook-form"
import { toast } from "react-toastify"
import { useHistory } from "react-router-dom"
import { BASEURL } from "../../../util"
import Logo from "../../../assets/logo.png"
import { GET_ROLE_PERMISSIONS } from "../../../GraphQl/queries"
import { useQuery } from "@apollo/client"
import { useState } from "react"
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai"
import { setAuthState } from "../../../store/features/authSlice"
import { useDispatch } from "react-redux"


type LoginType = {
  email: string
  password: string
}

export default function LoginEmail() {
  const history = useHistory()
  const dispatch = useDispatch()
  const [showPassword, setShowPassword] = useState(false)
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword)
  }

  const {
    register,
    handleSubmit,
    watch,
    formState: { isSubmitting, errors },
  } = useForm<LoginType>()

  const onSubmit: SubmitHandler<LoginType> = async (data) => {

    console.log(data)
    try {
      let options = {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({ ...data, usertype: "company_administrator" }),
      }

      const req = await fetch(
        `${process.env.REACT_APP_BASE_URL}/broker-login`,
        options
      )

      const res = await req.json()

      if (req.ok) {
        if (res?.access_token) {
          const { data } = res
          console.log(res)
          console.log(data)
          dispatch(setAuthState({
            usertype: data.user_type,
            userId: null,
            roleId: data?.role_id,
            companyId: data?.company_id,
            token: res?.access_token,
            expiresAt: res?.expires_at,
            showI2I: data?.has_invest_2_insure,
            user: data 
          }));
          history.push("/dashboard")


          // localStorage.setItem("usertype", "company_administrator")
          // localStorage.setItem("role_id", data?.role_id)
          // localStorage.setItem("company_id", data?.company_id)
          // localStorage.setItem("token", res?.access_token)
          // localStorage.setItem("expires_at", res?.expires_at)

          // localStorage.setItem("user", JSON.stringify(data))
        } else {
          toast.error(res?.data ?? "An error occured")
        }
      } else {
        toast.error(res?.data ?? "An error occured")
      }
    } catch (error: any) {
      toast.error(error?.message)
    }
  }

  return (
    <main className="w-full h-screen bg-white flex items-center justify-center">
      <form onSubmit={handleSubmit(onSubmit)} className="">
        <div className="mb-10 flex items-center justify-center">
          <img src={Logo} alt="logo" className="w-36 object-cover" />
        </div>
        <p className="mb-4 text-grey-700 font-bold">Login to your account</p>

        <div className="my-5" />
        <Input
          crossOrigin={""}
          id="email"
          error={!!errors.email}
          type="email"
          label="Email"
          size="lg"
          className="bg-gray-100 flex items-center w-full px-5 py-4 mr-2 text-sm font-medium outline-none focus:bg-grey-400 placeholder:text-grey-700 bg-grey-200 text-dark-grey-900 rounded-2xl"
          {...register("email", { required: true })}
        />
        {errors.email && (
          <span className="text-left mt-2 text-xs text-brand-primary">
            Email is required
          </span>
        )}
        {/* {usertype === "company_administrator" ? (
            <>
              <Input
                crossOrigin={""}
                id="email"
                error={!!errors.email}
                type="email"
                label="Email"
                size="lg"
                className="bg-gray-100 flex items-center w-full px-5 py-4 mr-2 text-sm font-medium outline-none focus:bg-grey-400 placeholder:text-grey-700 bg-grey-200 text-dark-grey-900 rounded-2xl"
                {...register("email", { required: true })}
              />
              {errors.email && (
                <span className="text-left mt-2 text-xs text-brand-primary">
                  Email is required
                </span>
              )}
            </>
          ) : (
            <>
              <Input
                crossOrigin={""}
                id="Username"
                error={!!errors.email}
                type="Username"
                label="Username"
                size="lg"
                className="bg-gray-100 flex items-center w-full px-5 py-4 mr-2 text-sm font-medium outline-none focus:bg-grey-400 placeholder:text-grey-700 bg-grey-200 text-dark-grey-900 rounded-2xl"
                {...register("email", { required: true })}
              />
              {errors.email && (
                <span className="text-left mt-2 text-xs text-brand-primary">
                  Username is required
                </span>
              )}
            </>
          )} */}

        <div className="my-6" />

        <div className="relative">
          <Input
            crossOrigin={""}
            id="password"
            error={!!errors.password}
            type={showPassword ? "text" : "password"}
            label="Password"
            size="lg"
            className="bg-gray-100 flex items-center w-full px-5 py-4 mr-2 text-sm font-medium outline-none focus:bg-grey-400 placeholder:text-grey-700 bg-grey-200 text-dark-grey-900 rounded-2xl"
            {...register("password", { required: true })}
          />
          <button
            type="button"
            className="absolute inset-y-0 right-0 px-3 py-2 text-sm font-medium text-gray-600 focus:outline-none"
            onClick={togglePasswordVisibility}
          >
            {showPassword ? <AiFillEyeInvisible /> : <AiFillEye />}
          </button>
          {errors.password && (
            <span className="text-left mt-2 text-xs text-brand-primary">
              Password is required
            </span>
          )}
        </div>
        <p className="text-xs leading-relaxed text-grey-900 mt-2 text-right">
          Forgot password?{" "}
          <a href="request-otp" className="font-bold text-red-500">
            Reset here
          </a>
        </p>

        <Button
          variant="gradient"
          size="lg"
          type="submit"
          style={{
            background: "#00308F",
          }}
          className="mt-5 flex items-center justify-center w-full text-sm font-bold leading-none text-white transition duration-300 md:w-96 rounded-2xl hover:bg-purple-blue-600 focus:ring-4 focus:ring-purple-blue-100 bg-purple-blue-500"
        >
          {isSubmitting ? (
            <Spinner className="w-5 h-5 text-white" />
          ) : (
            "Sign In"
          )}
        </Button>

        <p className="text-xs mt-5 text-center text-gray-700">
          Your number one insurance broker platform{" "}
        </p>
      </form>
    </main>
  )
}
